module.exports = __webpack_public_path__ + "img/1523185575.fa28e30a.jpg";